import { createFileRoute } from '@tanstack/react-router';
import { AuthCard, AuthShell } from '@/features/auth/layout/auth-layout';
import { ForgotPasswordForm } from '@/features/auth/forms/forgot-password-form';

export const Route = createFileRoute('/forgot-password')({
  component: ForgotPasswordPage,
});

function ForgotPasswordPage() {
  return (
    <AuthShell brandPane>
      <AuthCard title="Mot de passe oublié">
        <ForgotPasswordForm />
      </AuthCard>
    </AuthShell>
  );
}
